import React, { useState, useEffect } from "react";
import { useInView } from "react-intersection-observer";

const AnimatedCounter = ({ endValue }) => {
  const [count, setCount] = useState(0);
  const [ref, inView] = useInView();

  useEffect(() => {
    if (!inView) setCount(0);
    if (count < endValue) {
      const interval = setInterval(() => {
        setCount((prevCount) => prevCount + 1);
      }, 20);
      return () => clearInterval(interval);
    }
  }, [inView, count, endValue]);

  return <div ref={ref}>{count}</div>;
};

export default AnimatedCounter;
